import React, { PropTypes, PureComponent } from 'react';

class LegendTopRange extends PureComponent {

  render() {
    const rangeColors = this.props.items.map((item, itemIndex) =>
      <div key={`legendtop_rangecolor_${itemIndex}`} className="mt-scale-item-color" title={item.text}>
        <div style={{ background: item.color }} />
      </div>
    );

    return (
      <div className="mt-toplegend-range desk-mr+ lap-mr desk-mt--">
        {this.props.scale_icon ? <span className={`icon--small pr-- text--blue-dark ${this.props.scale_icon}`} style={{ minWidth: '15px' }}></span> : null}
        {this.props.from ? <span className="ph--" style={{ minWidth: '40px' }}>{this.props.from}</span> : null}
        <span className="mt-toplegend-range-colors ph--">
          <div className="mt-scale-wrapper">{rangeColors}</div>
        </span>
        {this.props.to ? <span className="ph--" style={{ minWidth: '40px' }}>{this.props.to}</span> : null}
      </div>
    );
  }
}

LegendTopRange.defaultProps = {
  text: '',
  scale_label: '',
  from: '',
  to: '',
  scale_icon: '',
  items: [],
};

LegendTopRange.propTypes = {
  text: PropTypes.string,
  scale_label: PropTypes.string,
  from: PropTypes.string,
  to: PropTypes.string,
  scale_icon: PropTypes.string,
  items: PropTypes.array,
};

export default LegendTopRange;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/LegendTop/LegendTopRange.js
 **/